import { useState } from 'react';
import type { Dispatch, SetStateAction, RefObject } from 'react';
import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

export const useDuplicateRef = (): MemoizedFn<
	(
		ref: React.RefCallback<HTMLElement> | React.MutableRefObject<HTMLElement | null> | null,
		setDuplicatedRef: Dispatch<SetStateAction<RefObject<HTMLElement> | null>>,
	) => (node: HTMLElement | null) => void
> => {
	const [createDuplicateRef] = useState(() =>
		memoizeOne(
			(
				ref: React.RefCallback<HTMLElement> | React.MutableRefObject<HTMLElement | null> | null,
				setDuplicatedRef: Dispatch<SetStateAction<RefObject<HTMLElement> | null>>,
			) => {
				return (node: HTMLElement | null) => {
					if (typeof ref === 'function') {
						ref(node);
					} else if (ref) {
						ref.current = node;
					}
					setDuplicatedRef({ current: node });
				};
			},
		),
	);

	return createDuplicateRef;
};
